import { useEffect, useState } from "react"
import InputBox from "../../../common/interactive/InputBox"
import { normalizeCurrencyRange } from "../../../../lib/filters"

export default function CurrencyRangeOption({ filtersValues, item, mainSelectAction, classes, workQ, isQuickFilter }) {
    const [hideItem, setHideItem] = useState(false)
    useEffect(() => {
        if (workQ?.filter_conditions?.[`${item.key}_filter_type`] === 1) {
            setHideItem(true)
        } else {
            setHideItem(false)
        }
    }, [workQ, item.key])

    function commitRange(nextRange, changedBound) {
        const normalized = normalizeCurrencyRange(nextRange, changedBound)
        mainSelectAction({
            data: {
                value: normalized,
            },
            identifier: { type: item.key },
            option: {
                label: normalized,
                value: normalized,
            },
        })
    }

    function updateBound(bound, payload) {
        const currentRange = filtersValues?.[item.key] || {}
        const rawValue = payload?.data?.value
        const nextRange = {
            ...currentRange,
            [bound]: rawValue == null || rawValue === '' ? undefined : rawValue,
        }
        if (nextRange.min === undefined) {
            delete nextRange.min
        }
        if (nextRange.max === undefined) {
            delete nextRange.max
        }
        commitRange(nextRange, bound)
    }

    if (hideItem) {
        return null
    }

    const range = filtersValues?.[item.key] || {}

    const compactStyle = isQuickFilter ? 'header_compact' : undefined

    return (
        <div className={classes.row}>
            <div className={`${classes.currency_range_block} ${isQuickFilter ? classes.currency_range_quick : ''}`}>
                {item.label ? (
                    <div className={isQuickFilter ? classes.currency_range_label : classes.label}>{item.label}</div>
                ) : null}
                <div className={classes.currency_range_row}>
                    <InputBox
                        label="Min"
                        name={`${item.key}_min`}
                        identifier={{ type: item.key, bound: 'min' }}
                        action={(payload) => updateBound('min', payload)}
                        currentValue={range.min ?? ''}
                        format="currency"
                        allowNegative={true}
                        isAFilter={true}
                        setStyle={compactStyle}
                    />
                    <InputBox
                        label="Max"
                        name={`${item.key}_max`}
                        identifier={{ type: item.key, bound: 'max' }}
                        action={(payload) => updateBound('max', payload)}
                        currentValue={range.max ?? ''}
                        format="currency"
                        allowNegative={true}
                        isAFilter={true}
                        setStyle={compactStyle}
                    />
                </div>
            </div>
        </div>
    )
}
